/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Status_ProcessingInputs */

const en_mcp_cap_status_processing = /** @type {(inputs: Mcp_Cap_Status_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing`)
};

const es_mcp_cap_status_processing = /** @type {(inputs: Mcp_Cap_Status_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando`)
};

/**
* | output |
* | --- |
* | "Processing" |
*
* @param {Mcp_Cap_Status_ProcessingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_status_processing = /** @type {((inputs?: Mcp_Cap_Status_ProcessingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Status_ProcessingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_status_processing(inputs)
	return en_mcp_cap_status_processing(inputs)
});